import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router'

import { getSetupState } from '@/domains/setup'

import { FullPageSpinner } from './full-page-spinner'
import { useUser } from './use-user'

/** post-login landing decision tree, driven by the active scope:
 *    not signed in             → /login
 *    super in Super scope      → /platform-metrics (super tools)
 *    no company on file        → /signup/finish
 *    company.status=onboarding → /onboarding
 *    otherwise                 → /suppliers
 */
export function RootRedirect() {
  const { user, isLoading } = useUser()

  const setupQuery = useQuery({
    queryKey: ['setup'],
    queryFn: ({ signal }) => getSetupState(signal),
    enabled: !!user
  })

  if (isLoading) return <FullPageSpinner />
  if (!user) return <Navigate to='/login' replace />

  if (setupQuery.isLoading) return <FullPageSpinner />
  const setup = setupQuery.data

  /** a super lands on the platform dashboard from Super scope. acting as a
   *  company, they follow the same flow as any owner. */
  if (user.isSuper && setup?.scope === 'super') {
    return <Navigate to='/super/platform-metrics' replace />
  }
  if (!setup?.hasCompany) return <Navigate to='/signup/finish' replace />
  if (setup.isOnboarding) return <Navigate to='/onboarding' replace />
  return <Navigate to='/suppliers' replace />
}
